module.exports = __webpack_public_path__ + "static/GPtoothTransp-b1661321e0c120975f15d68b11a9d763.png";